import React from 'react';
import { Text } from '@tamagui/core';
import { XStack, YStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import { FONT_SIZE_SECTION, ITEM_GAP } from '../constants';

type LocationSectionProps = {
  location: string;
  distance?: string;
  isDark?: boolean;
};

const LocationSection = React.memo<LocationSectionProps>(
  ({ location, distance, isDark }) => {
    const textColor = isDark ? COLORS.WHITE : COLORS.GRAY_900;

    return (
      <YStack gap={ITEM_GAP}>
        <Text fontSize={FONT_SIZE_SECTION} fontWeight="700" color={textColor}>
          Lokalizacja
        </Text>
        <XStack alignItems="center" justifyContent="space-between">
          <Text color={textColor}>{location}</Text>
          {distance ? (
            <XStack
              backgroundColor={COLORS.PRIMARY}
              paddingHorizontal="$3"
              paddingVertical="$1"
              borderRadius="$10"
              alignItems="center"
            >
              <Text color={COLORS.WHITE} fontSize={13} fontWeight="600">
                {distance}
              </Text>
            </XStack>
          ) : null}
        </XStack>
      </YStack>
    );
  },
);

LocationSection.displayName = 'LocationSection';

export default LocationSection;
